import { render } from "./BookingImportSelection.vue?vue&type=template&id=4ff017f0"
import script from "./BookingImportSelection.vue?vue&type=script&lang=js"
export * from "./BookingImportSelection.vue?vue&type=script&lang=js"
script.render = render

export default script